var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardViking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6656 70.27H92.1865V75.7491H97.6656V70.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6865 75.2491V70.77H97.1656V75.2491H92.6865Z",
    stroke: "url(#paint0_radial)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0096 70.27H67.5305V75.7491H73.0096V70.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0305 75.2491V70.77H72.5096V75.2491H68.0305Z",
    stroke: "url(#paint1_radial)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.582 70.27H114.103V75.7491H119.582V70.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.603 75.2491V70.77H119.082V75.2491H114.603Z",
    stroke: "url(#paint2_radial)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7492 92.1863C71.218 92.1863 67.5305 95.8737 67.5305 100.405C67.5305 104.936 71.218 108.624 75.7492 108.624C80.2804 108.624 83.9678 104.936 83.9678 100.405C83.9678 95.8737 80.2804 92.1863 75.7492 92.1863ZM75.7492 103.144C74.2397 103.144 73.0096 101.917 73.0096 100.405C73.0096 98.8927 74.2397 97.6654 75.7492 97.6654C77.2587 97.6654 78.4887 98.8927 78.4887 100.405C78.4887 101.917 77.2587 103.144 75.7492 103.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0305 100.405C68.0305 96.1499 71.4941 92.6863 75.7492 92.6863C80.0042 92.6863 83.4678 96.1499 83.4678 100.405C83.4678 104.66 80.0042 108.124 75.7492 108.124C71.4941 108.124 68.0305 104.66 68.0305 100.405ZM72.5096 100.405C72.5096 102.194 73.9639 103.644 75.7492 103.644C77.5345 103.644 78.9887 102.194 78.9887 100.405C78.9887 98.6162 77.5345 97.1654 75.7492 97.1654C73.9639 97.1654 72.5096 98.6162 72.5096 100.405Z",
    stroke: "url(#paint3_radial)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.103 92.1863C109.572 92.1863 105.884 95.8737 105.884 100.405C105.884 104.936 109.572 108.624 114.103 108.624C118.634 108.624 122.322 104.936 122.322 100.405C122.322 95.8737 118.634 92.1863 114.103 92.1863ZM114.103 103.144C112.593 103.144 111.363 101.917 111.363 100.405C111.363 98.8927 112.593 97.6654 114.103 97.6654C115.612 97.6654 116.842 98.8927 116.842 100.405C116.842 101.917 115.612 103.144 114.103 103.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.384 100.405C106.384 96.1499 109.848 92.6863 114.103 92.6863C118.358 92.6863 121.822 96.1499 121.822 100.405C121.822 104.66 118.358 108.124 114.103 108.124C109.848 108.124 106.384 104.66 106.384 100.405ZM110.863 100.405C110.863 102.194 112.318 103.644 114.103 103.644C115.888 103.644 117.342 102.194 117.342 100.405C117.342 98.6162 115.888 97.1654 114.103 97.1654C112.318 97.1654 110.863 98.6162 110.863 100.405Z",
    stroke: "url(#paint4_radial)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6724 64.0107C38.138 65.4489 39.716 66.7338 41.3597 67.8268L44.3952 63.2682C43.0363 62.3642 41.7296 61.2958 40.5077 60.1013L36.6724 64.0107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2229 67.1303C39.8874 66.2092 38.5982 65.159 37.382 64.0012L40.518 60.8048C41.5307 61.7619 42.5985 62.6349 43.7045 63.4033L41.2229 67.1303Z",
    stroke: "url(#paint5_radial)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6151 43.0991L25.4209 44.8442C27.2591 50.3124 29.6151 55.0792 32.4232 59.0186L36.8832 55.8353C34.3902 52.3369 32.2807 48.055 30.6151 43.0991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5424 58.3192C29.9739 54.6218 27.7924 50.2023 26.0559 45.1583L30.3022 43.7317C31.8898 48.3366 33.8666 52.363 36.1888 55.7166L32.5424 58.3192Z",
    stroke: "url(#paint6_radial)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dii)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.852 18.2186V16.2051C179.852 12.7834 177.069 10 173.647 10C171.453 10 169.401 11.1753 168.297 13.0656C165.116 18.5008 148.339 45.6141 130.54 45.6141H127.801V45.6689C123.242 39.2803 116.303 33.0971 105.884 30.4863V19.2652L98.3121 15.4791H91.5399L83.9678 19.2652V30.4863C73.5493 33.0971 66.6101 39.2776 62.0514 45.6689V45.6141H59.3119C41.513 45.6141 24.736 18.5008 21.5554 13.0656C20.4486 11.1753 18.3995 10 16.2051 10C12.7834 10 10 12.7834 10 16.2051V18.2186C10 18.8515 10.5479 78.938 53.8328 83.6446V84.2171C47.7263 85.2472 42.7486 89.6414 40.9076 95.4356L38.3817 96.2766C29.5987 99.2052 23.6977 107.391 23.6977 116.651C23.6977 120.902 24.9442 125.023 27.303 128.562L29.6371 132.061L29.7138 132.009C29.396 133.482 29.1768 134.978 29.1768 136.515C29.1768 142.227 31.4014 147.599 35.4395 151.637L38.1187 154.317C39.2146 158.96 41.5514 163.228 45.0087 166.686L50.9343 172.611C49.6632 173.707 48.0249 174.373 46.2607 174.373C43.5266 174.373 41.0665 172.853 39.8447 170.409L37.1051 164.93L32.204 167.382L34.9436 172.861C37.0037 176.981 41.0501 179.611 45.6141 179.838L54.3067 179.852C58.2818 179.852 62.0542 178.129 64.6595 175.126L72.9795 165.524C76.1135 169.524 82.5707 175.88 94.0576 179.707L94.926 180L95.7917 179.712C107.279 175.885 113.739 169.527 116.873 165.53L125.193 175.132C127.798 178.129 131.57 179.852 135.545 179.852H144.238V179.836C148.799 179.608 152.848 176.978 154.908 172.858L157.648 167.379L152.747 164.927L150.007 170.406C148.783 172.853 146.325 174.373 143.591 174.373C141.827 174.373 140.192 173.707 138.918 172.609L144.843 166.683C148.301 163.226 150.638 158.958 151.733 154.314L154.413 151.635C158.451 147.599 160.675 142.227 160.675 136.515C160.675 134.981 160.456 133.482 160.138 132.009L160.215 132.061L162.549 128.562C164.908 125.02 166.154 120.9 166.154 116.651C166.154 107.391 160.253 99.2052 151.47 96.2766L148.944 95.4356C147.101 89.6414 142.126 85.2472 136.019 84.2171V83.6446C179.304 78.938 179.852 18.8515 179.852 18.2186ZM130.54 122.469L121.609 120.034C118.5 116.385 113.917 114.103 108.892 114.103C103.054 114.103 97.9121 117.119 94.926 121.67C91.9372 117.119 86.7896 114.103 80.9379 114.103C75.93 114.103 71.3495 116.385 68.2428 120.034L59.3119 122.469V83.9678H61.4049L88.2224 97.3779L90.6742 92.4769L73.6562 83.9678H116.193L99.1778 92.4741L101.63 97.3752L128.447 83.9678H130.54V122.469ZM51.0932 73.0096C51.0932 69.9879 53.5506 67.5305 56.5723 67.5305H133.28C136.301 67.5305 138.759 69.9879 138.759 73.0096C138.759 75.5547 137.006 77.6833 134.649 78.2942C133.321 78.4175 131.957 78.4887 130.54 78.4887H59.3119C57.8901 78.4887 56.5148 78.4038 55.1587 78.2805C52.8246 77.6532 51.0932 75.5382 51.0932 73.0096ZM173.028 15.8325C173.359 15.2709 174.373 15.5476 174.373 16.2051V18.2186C174.373 18.7529 173.954 65.6786 143.668 76.3272C144.008 75.2725 144.238 74.1739 144.238 73.0096C144.238 67.7305 140.487 63.3171 135.512 62.2843C134.896 59.9009 133.587 55.7066 131.132 51.0713C151.144 50.5508 168.231 24.0238 173.028 15.8325ZM89.4469 22.6512L92.833 20.9582H97.0191L100.405 22.6512V29.4974C98.6573 29.3001 96.8437 29.1768 94.926 29.1768C93.0083 29.1768 91.1948 29.3001 89.4469 29.5001V22.6512ZM92.1865 34.7409V51.0932H97.6656V34.7409C120.094 36.1298 127.644 54.4821 129.814 62.0514H97.6656V56.5723H92.1865V62.0514H60.0269C62.172 54.4848 69.6756 36.1243 92.1865 34.7409ZM21.1774 48.8961C15.5585 33.782 15.4791 18.3721 15.4791 18.2186V16.2051C15.4791 15.5476 16.4927 15.2682 16.827 15.8325C21.6212 24.0238 38.7105 50.5508 58.7201 51.0686C56.2655 55.7039 54.956 59.8982 54.3396 62.2816C49.3646 63.3171 45.6141 67.7305 45.6141 73.0096C45.6141 74.2068 45.8552 75.3355 46.2114 76.4149C34.9546 72.574 26.5551 63.3774 21.1774 48.8961ZM53.8328 89.836V110.974C49.1208 109.75 45.6141 105.498 45.6141 100.405C45.6141 95.3123 49.1208 91.0605 53.8328 89.836ZM31.8616 125.521C30.1056 122.886 29.1768 119.818 29.1768 116.651C29.1768 109.752 33.5711 103.654 40.1159 101.474L40.1898 101.449C40.3898 104.621 41.4856 107.544 43.239 109.98L33.1602 124.089C32.7547 124.656 32.4342 125.264 32.089 125.861L31.8616 125.521ZM34.6559 136.515C34.6559 133.181 35.6805 129.987 37.6201 127.272L47.1866 113.881C49.1372 115.245 51.3946 116.185 53.8355 116.596V124.149C44.8635 127.702 38.5571 136.008 37.5544 145.616C35.686 142.964 34.6559 139.825 34.6559 136.515ZM42.8746 148.301C42.8746 139.074 49.0906 130.935 57.9942 128.507L64.7526 126.664L53.6054 167.53L48.8824 162.807C45.0087 158.936 42.8746 153.783 42.8746 148.301ZM60.52 171.538C59.5584 172.647 58.3311 173.463 56.9751 173.929C57.6271 172.894 58.1339 171.754 58.4681 170.529L70.1057 127.855C71.4344 122.987 75.8889 119.582 80.9571 119.582C87.1512 119.582 92.1865 124.62 92.1865 130.811C92.1865 133.51 91.2112 136.121 89.4442 138.164L60.52 171.538ZM94.926 174.214C84.376 170.472 78.8668 164.33 76.656 161.286L93.5864 141.75C94.0905 141.167 94.5124 140.529 94.9288 139.888C95.3452 140.529 95.7643 141.167 96.2712 141.75L113.202 161.283C110.98 164.338 105.471 170.475 94.926 174.214ZM129.335 171.538L100.408 138.164C98.6409 136.121 97.6656 133.51 97.6656 130.811C97.6656 124.62 102.701 119.582 108.914 119.582C113.963 119.582 118.418 122.984 119.746 127.855L131.387 170.529C131.721 171.754 132.23 172.894 132.88 173.929C131.521 173.463 130.294 172.647 129.335 171.538ZM140.97 162.809L136.247 167.532L125.099 126.666L131.858 128.51C140.761 130.937 146.977 139.074 146.977 148.301C146.977 153.783 144.843 158.936 140.97 162.809ZM152.3 145.616C151.298 136.006 144.991 127.702 136.019 124.149V116.596C138.46 116.185 140.718 115.243 142.668 113.881L152.235 127.272C154.172 129.987 155.196 133.181 155.196 136.515C155.196 139.825 154.166 142.964 152.3 145.616ZM160.675 116.651C160.675 119.818 159.747 122.886 157.99 125.521L157.763 125.861C157.418 125.264 157.097 124.656 156.692 124.089L146.613 109.98C148.364 107.547 149.462 104.621 149.662 101.449L149.736 101.474C156.281 103.654 160.675 109.752 160.675 116.651ZM144.238 100.405C144.238 105.498 140.731 109.75 136.019 110.974V89.836C140.731 91.0605 144.238 95.3123 144.238 100.405Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.852 18.2186V16.2051C179.852 12.7834 177.069 10 173.647 10C171.453 10 169.401 11.1753 168.297 13.0656C165.116 18.5008 148.339 45.6141 130.54 45.6141H127.801V45.6689C123.242 39.2803 116.303 33.0971 105.884 30.4863V19.2652L98.3121 15.4791H91.5399L83.9678 19.2652V30.4863C73.5493 33.0971 66.6101 39.2776 62.0514 45.6689V45.6141H59.3119C41.513 45.6141 24.736 18.5008 21.5554 13.0656C20.4486 11.1753 18.3995 10 16.2051 10C12.7834 10 10 12.7834 10 16.2051V18.2186C10 18.8515 10.5479 78.938 53.8328 83.6446V84.2171C47.7263 85.2472 42.7486 89.6414 40.9076 95.4356L38.3817 96.2766C29.5987 99.2052 23.6977 107.391 23.6977 116.651C23.6977 120.902 24.9442 125.023 27.303 128.562L29.6371 132.061L29.7138 132.009C29.396 133.482 29.1768 134.978 29.1768 136.515C29.1768 142.227 31.4014 147.599 35.4395 151.637L38.1187 154.317C39.2146 158.96 41.5514 163.228 45.0087 166.686L50.9343 172.611C49.6632 173.707 48.0249 174.373 46.2607 174.373C43.5266 174.373 41.0665 172.853 39.8447 170.409L37.1051 164.93L32.204 167.382L34.9436 172.861C37.0037 176.981 41.0501 179.611 45.6141 179.838L54.3067 179.852C58.2818 179.852 62.0542 178.129 64.6595 175.126L72.9795 165.524C76.1135 169.524 82.5707 175.88 94.0576 179.707L94.926 180L95.7917 179.712C107.279 175.885 113.739 169.527 116.873 165.53L125.193 175.132C127.798 178.129 131.57 179.852 135.545 179.852H144.238V179.836C148.799 179.608 152.848 176.978 154.908 172.858L157.648 167.379L152.747 164.927L150.007 170.406C148.783 172.853 146.325 174.373 143.591 174.373C141.827 174.373 140.192 173.707 138.918 172.609L144.843 166.683C148.301 163.226 150.638 158.958 151.733 154.314L154.413 151.635C158.451 147.599 160.675 142.227 160.675 136.515C160.675 134.981 160.456 133.482 160.138 132.009L160.215 132.061L162.549 128.562C164.908 125.02 166.154 120.9 166.154 116.651C166.154 107.391 160.253 99.2052 151.47 96.2766L148.944 95.4356C147.101 89.6414 142.126 85.2472 136.019 84.2171V83.6446C179.304 78.938 179.852 18.8515 179.852 18.2186ZM130.54 122.469L121.609 120.034C118.5 116.385 113.917 114.103 108.892 114.103C103.054 114.103 97.9121 117.119 94.926 121.67C91.9372 117.119 86.7896 114.103 80.9379 114.103C75.93 114.103 71.3495 116.385 68.2428 120.034L59.3119 122.469V83.9678H61.4049L88.2224 97.3779L90.6742 92.4769L73.6562 83.9678H116.193L99.1778 92.4741L101.63 97.3752L128.447 83.9678H130.54V122.469ZM51.0932 73.0096C51.0932 69.9879 53.5506 67.5305 56.5723 67.5305H133.28C136.301 67.5305 138.759 69.9879 138.759 73.0096C138.759 75.5547 137.006 77.6833 134.649 78.2942C133.321 78.4175 131.957 78.4887 130.54 78.4887H59.3119C57.8901 78.4887 56.5148 78.4038 55.1587 78.2805C52.8246 77.6532 51.0932 75.5382 51.0932 73.0096ZM173.028 15.8325C173.359 15.2709 174.373 15.5476 174.373 16.2051V18.2186C174.373 18.7529 173.954 65.6786 143.668 76.3272C144.008 75.2725 144.238 74.1739 144.238 73.0096C144.238 67.7305 140.487 63.3171 135.512 62.2843C134.896 59.9009 133.587 55.7066 131.132 51.0713C151.144 50.5508 168.231 24.0238 173.028 15.8325ZM89.4469 22.6512L92.833 20.9582H97.0191L100.405 22.6512V29.4974C98.6573 29.3001 96.8437 29.1768 94.926 29.1768C93.0083 29.1768 91.1948 29.3001 89.4469 29.5001V22.6512ZM92.1865 34.7409V51.0932H97.6656V34.7409C120.094 36.1298 127.644 54.4821 129.814 62.0514H97.6656V56.5723H92.1865V62.0514H60.0269C62.172 54.4848 69.6756 36.1243 92.1865 34.7409ZM21.1774 48.8961C15.5585 33.782 15.4791 18.3721 15.4791 18.2186V16.2051C15.4791 15.5476 16.4927 15.2682 16.827 15.8325C21.6212 24.0238 38.7105 50.5508 58.7201 51.0686C56.2655 55.7039 54.956 59.8982 54.3396 62.2816C49.3646 63.3171 45.6141 67.7305 45.6141 73.0096C45.6141 74.2068 45.8552 75.3355 46.2114 76.4149C34.9546 72.574 26.5551 63.3774 21.1774 48.8961ZM53.8328 89.836V110.974C49.1208 109.75 45.6141 105.498 45.6141 100.405C45.6141 95.3123 49.1208 91.0605 53.8328 89.836ZM31.8616 125.521C30.1056 122.886 29.1768 119.818 29.1768 116.651C29.1768 109.752 33.5711 103.654 40.1159 101.474L40.1898 101.449C40.3898 104.621 41.4856 107.544 43.239 109.98L33.1602 124.089C32.7547 124.656 32.4342 125.264 32.089 125.861L31.8616 125.521ZM34.6559 136.515C34.6559 133.181 35.6805 129.987 37.6201 127.272L47.1866 113.881C49.1372 115.245 51.3946 116.185 53.8355 116.596V124.149C44.8635 127.702 38.5571 136.008 37.5544 145.616C35.686 142.964 34.6559 139.825 34.6559 136.515ZM42.8746 148.301C42.8746 139.074 49.0906 130.935 57.9942 128.507L64.7526 126.664L53.6054 167.53L48.8824 162.807C45.0087 158.936 42.8746 153.783 42.8746 148.301ZM60.52 171.538C59.5584 172.647 58.3311 173.463 56.9751 173.929C57.6271 172.894 58.1339 171.754 58.4681 170.529L70.1057 127.855C71.4344 122.987 75.8889 119.582 80.9571 119.582C87.1512 119.582 92.1865 124.62 92.1865 130.811C92.1865 133.51 91.2112 136.121 89.4442 138.164L60.52 171.538ZM94.926 174.214C84.376 170.472 78.8668 164.33 76.656 161.286L93.5864 141.75C94.0905 141.167 94.5124 140.529 94.9288 139.888C95.3452 140.529 95.7643 141.167 96.2712 141.75L113.202 161.283C110.98 164.338 105.471 170.475 94.926 174.214ZM129.335 171.538L100.408 138.164C98.6409 136.121 97.6656 133.51 97.6656 130.811C97.6656 124.62 102.701 119.582 108.914 119.582C113.963 119.582 118.418 122.984 119.746 127.855L131.387 170.529C131.721 171.754 132.23 172.894 132.88 173.929C131.521 173.463 130.294 172.647 129.335 171.538ZM140.97 162.809L136.247 167.532L125.099 126.666L131.858 128.51C140.761 130.937 146.977 139.074 146.977 148.301C146.977 153.783 144.843 158.936 140.97 162.809ZM152.3 145.616C151.298 136.006 144.991 127.702 136.019 124.149V116.596C138.46 116.185 140.718 115.243 142.668 113.881L152.235 127.272C154.172 129.987 155.196 133.181 155.196 136.515C155.196 139.825 154.166 142.964 152.3 145.616ZM160.675 116.651C160.675 119.818 159.747 122.886 157.99 125.521L157.763 125.861C157.418 125.264 157.097 124.656 156.692 124.089L146.613 109.98C148.364 107.547 149.462 104.621 149.662 101.449L149.736 101.474C156.281 103.654 160.675 109.752 160.675 116.651ZM144.238 100.405C144.238 105.498 140.731 109.75 136.019 110.974V89.836C140.731 91.0605 144.238 95.3123 144.238 100.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.852 18.2186V16.2051C179.852 12.7834 177.069 10 173.647 10C171.453 10 169.401 11.1753 168.297 13.0656C165.116 18.5008 148.339 45.6141 130.54 45.6141H127.801V45.6689C123.242 39.2803 116.303 33.0971 105.884 30.4863V19.2652L98.3121 15.4791H91.5399L83.9678 19.2652V30.4863C73.5493 33.0971 66.6101 39.2776 62.0514 45.6689V45.6141H59.3119C41.513 45.6141 24.736 18.5008 21.5554 13.0656C20.4486 11.1753 18.3995 10 16.2051 10C12.7834 10 10 12.7834 10 16.2051V18.2186C10 18.8515 10.5479 78.938 53.8328 83.6446V84.2171C47.7263 85.2472 42.7486 89.6414 40.9076 95.4356L38.3817 96.2766C29.5987 99.2052 23.6977 107.391 23.6977 116.651C23.6977 120.902 24.9442 125.023 27.303 128.562L29.6371 132.061L29.7138 132.009C29.396 133.482 29.1768 134.978 29.1768 136.515C29.1768 142.227 31.4014 147.599 35.4395 151.637L38.1187 154.317C39.2146 158.96 41.5514 163.228 45.0087 166.686L50.9343 172.611C49.6632 173.707 48.0249 174.373 46.2607 174.373C43.5266 174.373 41.0665 172.853 39.8447 170.409L37.1051 164.93L32.204 167.382L34.9436 172.861C37.0037 176.981 41.0501 179.611 45.6141 179.838L54.3067 179.852C58.2818 179.852 62.0542 178.129 64.6595 175.126L72.9795 165.524C76.1135 169.524 82.5707 175.88 94.0576 179.707L94.926 180L95.7917 179.712C107.279 175.885 113.739 169.527 116.873 165.53L125.193 175.132C127.798 178.129 131.57 179.852 135.545 179.852H144.238V179.836C148.799 179.608 152.848 176.978 154.908 172.858L157.648 167.379L152.747 164.927L150.007 170.406C148.783 172.853 146.325 174.373 143.591 174.373C141.827 174.373 140.192 173.707 138.918 172.609L144.843 166.683C148.301 163.226 150.638 158.958 151.733 154.314L154.413 151.635C158.451 147.599 160.675 142.227 160.675 136.515C160.675 134.981 160.456 133.482 160.138 132.009L160.215 132.061L162.549 128.562C164.908 125.02 166.154 120.9 166.154 116.651C166.154 107.391 160.253 99.2052 151.47 96.2766L148.944 95.4356C147.101 89.6414 142.126 85.2472 136.019 84.2171V83.6446C179.304 78.938 179.852 18.8515 179.852 18.2186ZM130.54 122.469L121.609 120.034C118.5 116.385 113.917 114.103 108.892 114.103C103.054 114.103 97.9121 117.119 94.926 121.67C91.9372 117.119 86.7896 114.103 80.9379 114.103C75.93 114.103 71.3495 116.385 68.2428 120.034L59.3119 122.469V83.9678H61.4049L88.2224 97.3779L90.6742 92.4769L73.6562 83.9678H116.193L99.1778 92.4741L101.63 97.3752L128.447 83.9678H130.54V122.469ZM51.0932 73.0096C51.0932 69.9879 53.5506 67.5305 56.5723 67.5305H133.28C136.301 67.5305 138.759 69.9879 138.759 73.0096C138.759 75.5547 137.006 77.6833 134.649 78.2942C133.321 78.4175 131.957 78.4887 130.54 78.4887H59.3119C57.8901 78.4887 56.5148 78.4038 55.1587 78.2805C52.8246 77.6532 51.0932 75.5382 51.0932 73.0096ZM173.028 15.8325C173.359 15.2709 174.373 15.5476 174.373 16.2051V18.2186C174.373 18.7529 173.954 65.6786 143.668 76.3272C144.008 75.2725 144.238 74.1739 144.238 73.0096C144.238 67.7305 140.487 63.3171 135.512 62.2843C134.896 59.9009 133.587 55.7066 131.132 51.0713C151.144 50.5508 168.231 24.0238 173.028 15.8325ZM89.4469 22.6512L92.833 20.9582H97.0191L100.405 22.6512V29.4974C98.6573 29.3001 96.8437 29.1768 94.926 29.1768C93.0083 29.1768 91.1948 29.3001 89.4469 29.5001V22.6512ZM92.1865 34.7409V51.0932H97.6656V34.7409C120.094 36.1298 127.644 54.4821 129.814 62.0514H97.6656V56.5723H92.1865V62.0514H60.0269C62.172 54.4848 69.6756 36.1243 92.1865 34.7409ZM21.1774 48.8961C15.5585 33.782 15.4791 18.3721 15.4791 18.2186V16.2051C15.4791 15.5476 16.4927 15.2682 16.827 15.8325C21.6212 24.0238 38.7105 50.5508 58.7201 51.0686C56.2655 55.7039 54.956 59.8982 54.3396 62.2816C49.3646 63.3171 45.6141 67.7305 45.6141 73.0096C45.6141 74.2068 45.8552 75.3355 46.2114 76.4149C34.9546 72.574 26.5551 63.3774 21.1774 48.8961ZM53.8328 89.836V110.974C49.1208 109.75 45.6141 105.498 45.6141 100.405C45.6141 95.3123 49.1208 91.0605 53.8328 89.836ZM31.8616 125.521C30.1056 122.886 29.1768 119.818 29.1768 116.651C29.1768 109.752 33.5711 103.654 40.1159 101.474L40.1898 101.449C40.3898 104.621 41.4856 107.544 43.239 109.98L33.1602 124.089C32.7547 124.656 32.4342 125.264 32.089 125.861L31.8616 125.521ZM34.6559 136.515C34.6559 133.181 35.6805 129.987 37.6201 127.272L47.1866 113.881C49.1372 115.245 51.3946 116.185 53.8355 116.596V124.149C44.8635 127.702 38.5571 136.008 37.5544 145.616C35.686 142.964 34.6559 139.825 34.6559 136.515ZM42.8746 148.301C42.8746 139.074 49.0906 130.935 57.9942 128.507L64.7526 126.664L53.6054 167.53L48.8824 162.807C45.0087 158.936 42.8746 153.783 42.8746 148.301ZM60.52 171.538C59.5584 172.647 58.3311 173.463 56.9751 173.929C57.6271 172.894 58.1339 171.754 58.4681 170.529L70.1057 127.855C71.4344 122.987 75.8889 119.582 80.9571 119.582C87.1512 119.582 92.1865 124.62 92.1865 130.811C92.1865 133.51 91.2112 136.121 89.4442 138.164L60.52 171.538ZM94.926 174.214C84.376 170.472 78.8668 164.33 76.656 161.286L93.5864 141.75C94.0905 141.167 94.5124 140.529 94.9288 139.888C95.3452 140.529 95.7643 141.167 96.2712 141.75L113.202 161.283C110.98 164.338 105.471 170.475 94.926 174.214ZM129.335 171.538L100.408 138.164C98.6409 136.121 97.6656 133.51 97.6656 130.811C97.6656 124.62 102.701 119.582 108.914 119.582C113.963 119.582 118.418 122.984 119.746 127.855L131.387 170.529C131.721 171.754 132.23 172.894 132.88 173.929C131.521 173.463 130.294 172.647 129.335 171.538ZM140.97 162.809L136.247 167.532L125.099 126.666L131.858 128.51C140.761 130.937 146.977 139.074 146.977 148.301C146.977 153.783 144.843 158.936 140.97 162.809ZM152.3 145.616C151.298 136.006 144.991 127.702 136.019 124.149V116.596C138.46 116.185 140.718 115.243 142.668 113.881L152.235 127.272C154.172 129.987 155.196 133.181 155.196 136.515C155.196 139.825 154.166 142.964 152.3 145.616ZM160.675 116.651C160.675 119.818 159.747 122.886 157.99 125.521L157.763 125.861C157.418 125.264 157.097 124.656 156.692 124.089L146.613 109.98C148.364 107.547 149.462 104.621 149.662 101.449L149.736 101.474C156.281 103.654 160.675 109.752 160.675 116.651ZM144.238 100.405C144.238 105.498 140.731 109.75 136.019 110.974V89.836C140.731 91.0605 144.238 95.3123 144.238 100.405Z",
    stroke: "url(#paint7_radial)",
    strokeWidth: 2,
    mask: "url(#path-15-inside-1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii",
    x: 82.1865,
    y: 60.27,
    width: 25.4791,
    height: 25.4791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii",
    x: 57.5305,
    y: 60.27,
    width: 25.4791,
    height: 25.4791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii",
    x: 104.103,
    y: 60.27,
    width: 25.4791,
    height: 25.4791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii",
    x: 57.5305,
    y: 82.1863,
    width: 36.4373,
    height: 36.4373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii",
    x: 95.8843,
    y: 82.1863,
    width: 36.4373,
    height: 36.4373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dii",
    x: 26.6724,
    y: 50.1013,
    width: 27.7228,
    height: 27.7255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dii",
    x: 15.4209,
    y: 33.0991,
    width: 31.4623,
    height: 35.9195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.258824 0 0 0 0 0.607843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dii",
    x: 0,
    y: 0,
    width: 189.852,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.160784 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.160784 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.160784 0 0 0 0 0.172549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.9202 73.0096) rotate(89.8779) scale(2.73956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA429B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.2642 73.0096) rotate(89.8779) scale(2.73956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA429B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.836 73.0096) rotate(89.8779) scale(2.73956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA429B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.7317 100.405) rotate(89.8779) scale(8.21867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA429B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.085 100.405) rotate(89.8779) scale(8.21867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA429B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5255 63.9641) rotate(89.878) scale(3.86277 3.8614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA429B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1398 51.0589) rotate(89.9121) scale(7.95977 5.73116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA429B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.7451 95) rotate(89.878) scale(85.0002 84.9262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2292C",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardViking);
export default __webpack_public_path__ + "static/media/dashboard-viking.d5ed3dbe.svg";
export { ForwardRef as ReactComponent };